<div>
  
        <!-- <div class="example-ripple-container mat-elevation-z4" matRipple *ngFor="let item of menus">
            <img mat-card-image class="ripple-image" [src]="item.image" alt="{{item.name}}">
            <mat-panel-title class="title">
                {{item.name}}
            </mat-panel-title>
            <mat-panel-title class="title">{{item.description}}</mat-panel-title>
        </div> -->
        <mat-card class="example-ripple-container" appearance="raised" *ngFor="let item of signature" >
            <mat-card-header>
                <div mat-card-avatar ></div>
                <mat-card-title class="title">{{item.text}}</mat-card-title>
            </mat-card-header>
            <img mat-card-image [src]="item.image" alt="item.name" class="ripple-image">
            <mat-card-content>
                <p>
                  {{item.description}}
                </p>
            </mat-card-content>
            <mat-card-actions>
                <div class="example-button-row">
                    <button  *ngIf="!item.like" type="button" class="buttoncolor"(click)="toggleLike(item)"> <mat-icon class="btn-iconOrange" inline="false" >thumb_up_alt</mat-icon></button>
                    <button  *ngIf="item.like" type="button" class="buttoncolor" (click)="toggleLike(item)"> <mat-icon class="btn-icongreen" inline="false">thumb_up_alt</mat-icon></button>
                    <button type="button" class="buttoncolor" ><mat-icon class="btn-iconOrange" (click)="shareContent(item)">share</mat-icon></button>
                </div>
            </mat-card-actions>
        </mat-card>
</div>